import { useState } from "react";
import { Copy, Check, Download } from "lucide-react";

const Cmd = ({ id, text }) => {
  const [done, setDone] = useState(false);
  const copy = () => {
    navigator.clipboard?.writeText(text).then(() => { setDone(true); setTimeout(() => setDone(false), 1500); });
  };
  return (
    <div className="flex items-stretch gap-2">
      <code data-testid={`${id}-cmd`} className="flex-1 border border-emerald-400/30 bg-slate-900 p-2.5 font-mono text-xs text-emerald-200 break-all">{text}</code>
      <button type="button" data-testid={`${id}-copy`} onClick={copy} className="lab-btn-ghost px-3 py-1 text-xs" aria-label="Copy command">
        {done ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </div>
  );
};

export const BridgePanel = ({ online, lastPush }) => {
  const origin = window.location.origin;
  const api = process.env.REACT_APP_BACKEND_URL;
  return (
    <div data-testid="bridge-panel" className="mt-4 border border-emerald-400/30 bg-slate-950/60 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="lab-label !text-emerald-300">Reader bridge · skips keyboard emulation entirely</p>
        <span data-testid="bridge-status" data-state={online ? "online" : "offline"} className={`flex items-center gap-2 font-mono text-xs uppercase tracking-widest ${online ? "text-emerald-300" : "text-slate-500"}`}>
          <span className={`h-2 w-2 rounded-full ${online ? "bg-emerald-400 animate-pulse" : "bg-slate-600"}`} />
          {online ? `Bridge online${lastPush ? ` · last tag ${lastPush.uid}` : ""}` : "Bridge offline"}
        </span>
      </div>
      <p className="mt-2 text-sm text-slate-400">
        A tiny helper reads the ACR1252U directly and pushes every tag to the kiosk - no focus, no typing, no Accessibility
        permission. On the Mac that has the reader plugged in, open Terminal and run these three lines (once per session):
      </p>
      <div className="mt-3 grid gap-2">
        <Cmd id="bridge-install" text="pip3 install pyscard" />
        <Cmd id="bridge-download" text={`curl -o reader_bridge.py ${api}/api/reader/bridge.py`} />
        <Cmd id="bridge-run" text={`python3 reader_bridge.py ${origin} <setup passcode>`} />
      </div>
      <p className="mt-3 flex flex-wrap items-center gap-3 text-xs text-slate-500">
        <a data-testid="bridge-download-link" href={`${api}/api/reader/bridge.py`} className="inline-flex items-center gap-1 text-emerald-300 underline-offset-4 hover:underline">
          <Download size={12} /> download reader_bridge.py
        </a>
        <span>Leave the Terminal window open while the exhibit runs. Quit the keyboard-emulator app so tags aren't sent twice.</span>
      </p>
    </div>
  );
};
